import type { QR_CODE_VISIBLE } from '../../../constants';
import { QR_CODE_HIDDEN } from '../../../constants';

export const qrCodeVisibilityToQuestionHideJoinInstructions = (
  qrCodeVisibility: typeof QR_CODE_HIDDEN | typeof QR_CODE_VISIBLE,
) => {
  return qrCodeVisibility === QR_CODE_HIDDEN;
};
